import { gql } from '@apollo/client';

export interface SendClinicianInviteInput {
  clinicianId: string;
}

export const SEND_CLINICIAN_INVITE = gql`
  mutation sendClinicianInvite($clinicianId: ID!) {
    sendClinicianInvite(clinicianId: $clinicianId) {
      id
    }
  }
`;
